import createAction, {ReducerActionInterface} from "../../../../lib/reducer.utils";
import {RootReducerState} from "../../../../store/root-reducer";

export interface FileModel {
    url: string;
    mimeType: string;
}

export interface AdvancedFileManagerModel {
    imagesCurrentPage: number;
    imagesMaximumPage: number;
    audiosCurrentPage: number;
    audiosMaximumPage: number;
    uploadedFiles: FileModel[];
    isUploading: boolean;
}

const INITIAL_STATE: AdvancedFileManagerModel =
    {
        audiosMaximumPage: 1,
        audiosCurrentPage: 1,
        imagesCurrentPage: 1,
        imagesMaximumPage: 1,
        uploadedFiles: [],
        isUploading: false
    }

const ActionTypes = {
    SET_AUDIO_MAX_PAGE: "SET_AUDIO_MAX_PAGE",
    SET_AUDIO_CURRENT_PAGE: "SET_AUDIO_CURRENT_PAGE",
    SET_IMAGES_MAX_PAGE: "SET_IMAGES_MAX_PAGE",
    SET_IMAGES_CURRENT_PAGE: "SET_IMAGES_CURRENT_PAGE",
    UPLOAD_FILE: "UPLOAD_FILE",
    REMOVE_FILE: "REMOVE_FILE",
    SET_IS_UPLOADING: "SET_IS_UPLOADING",
    SET_UPLOADED_FILES: "SET_UPLOADED_FILES"
}

export const advancedFileManagerReducer = (state = INITIAL_STATE, action: ReducerActionInterface) => {
    const {type, payload} = action;

    switch (type) {
        case ActionTypes.SET_AUDIO_CURRENT_PAGE:
            return {
                ...state,
                audiosCurrentPage: payload
            }

        case ActionTypes.SET_AUDIO_MAX_PAGE:
            return {
                ...state,
                audiosMaximumPage: payload
            }

        case ActionTypes.SET_IMAGES_CURRENT_PAGE:
            return {
                ...state,
                imagesCurrentPage: payload
            }

        case ActionTypes.SET_IMAGES_MAX_PAGE:
            return {
                ...state,
                imagesMaximumPage: payload
            }

        case ActionTypes.SET_UPLOADED_FILES:
            return {
                ...state,
                uploadedFiles: payload
            }

        case ActionTypes.SET_IS_UPLOADING:
            return {
                ...state,
                isUploading: payload
            }

        case ActionTypes.UPLOAD_FILE:
            const oldFiles = state.uploadedFiles;
            oldFiles.push(payload)

            return {
                ...state.uploadedFiles,
                uploadedFiles: oldFiles
            }

        case ActionTypes.REMOVE_FILE:
            return {
                ...state.uploadedFiles,
                uploadedFiles: state.uploadedFiles.filter(file => file.url != payload)
            }

        default:
            return state;
    }
}

/* Selectors */
export const getFileManagerFiles = (state: RootReducerState) => state.advancedFileManager.uploadedFiles;
export const getIsFileUploading = (state: RootReducerState) => state.advancedFileManager.isUploading;
export const getImagesMaximumPage = (state: RootReducerState) => state.advancedFileManager.imagesMaximumPage;
export const getImagesCurrentPage = (state: RootReducerState) => state.advancedFileManager.imagesCurrentPage;
export const getAudiosMaximumPage = (state: RootReducerState) => state.advancedFileManager.audiosMaximumPage;
export const getAudiosCurrentPage = (state: RootReducerState) => state.advancedFileManager.audiosCurrentPage;

/* Actions */
export const setImagesMaximumPage = (payload: number) => createAction({
    type: ActionTypes.SET_IMAGES_MAX_PAGE,
    payload
})

export const setImagesCurrentPage = (payload: number) => createAction({
    type: ActionTypes.SET_IMAGES_CURRENT_PAGE,
    payload
})

export const setAudiosCurrentPage = (payload: number) => createAction({
    type: ActionTypes.SET_AUDIO_CURRENT_PAGE,
    payload
})

export const setAudiosMaximumPage = (payload: number) => createAction({
    type: ActionTypes.SET_AUDIO_MAX_PAGE,
    payload
})

export const setUpladedFiles = (payload: FileModel[]) => createAction({
    type: ActionTypes.SET_UPLOADED_FILES,
    payload
})

export const setIsFileUploading = (payload: boolean) => createAction({
    type: ActionTypes.SET_IS_UPLOADING,
    payload
})

export const uploadFile = (payload: FileModel) => createAction({
    type: ActionTypes.UPLOAD_FILE,
    payload
})

export const removeFile = (payload: string) => createAction({
    type: ActionTypes.REMOVE_FILE,
    payload
})